import {
  ADDPRODUCT,
  PRODUCTDECREMENT,
  PRODUCTINCREMENT,
  PRODUCTREMOVED,
} from "./actionTypes";

export const addProduct = (
  productName,
  category,
  imgUrl,
  price,
  quantity,
  stock
) => {
  return {
    type: ADDPRODUCT,
    payload: {
      productName,
      category,
      imgUrl,
      price,
      quantity,
      stock,
    },
  };
};

export const productIncrement = (id) => {
  return {
    type: PRODUCTINCREMENT,
    payload: {
      id,
    },
  };
};
export const productDecrement = (id) => {
  return {
    type: PRODUCTDECREMENT,
    payload: {
      id,
    },
  };
};
export const productRemoved = (id) => {
  return {
    type: PRODUCTREMOVED,
    payload: {
      id,
    },
  };
};
